/**
 * VEV Form Overlay Fix
 * Ensures the close button is visible and clickable above the navigation
 * when the VEV form overlay is open.
 */
(function() {
    'use strict';

    var VEV_FORM_STYLE_ID = 'vev-form-overlay-fix-styles';

    function findShadowRoot(element) {
        if (element.shadowRoot) return element.shadowRoot;
        for (var i = 0; i < element.children.length; i++) {
            var sr = findShadowRoot(element.children[i]);
            if (sr) return sr;
        }
        return null;
    }

    function initVevFormOverlay() {
        var vevContainer = document.querySelector('.vev');
        if (!vevContainer) return;

        var shadowRoot = findShadowRoot(vevContainer);
        if (!shadowRoot) return;

        var formContainer = shadowRoot.querySelector('.fixed');
        var closeButton = shadowRoot.querySelector('#eFBSP-F08EL');
        var triggerButton = shadowRoot.querySelector('#ecFMWgfonHu');

        if (!formContainer || !closeButton) return;

        // Don't initialize twice
        if (shadowRoot.querySelector('#' + VEV_FORM_STYLE_ID)) return;

        // Create a style element to inject into the shadow DOM
        var styleEl = document.createElement('style');
        styleEl.id = VEV_FORM_STYLE_ID;
        styleEl.textContent = [
            // Make the fixed form container appear above the VEV header (z-index: 10)
            '.fixed {',
            '    z-index: 100 !important;',
            '}',
            // Style the close button - positioned at top-right of form, gray color
            '#eFBSP-F08EL {',
            '    position: fixed !important;',
            '    top: 54px !important;',
            '    right: 3.5% !important;',
            '    left: auto !important;',
            '    z-index: 9999 !important;',
            '    cursor: pointer !important;',
            '    width: 32px !important;',
            '    height: 32px !important;',
            '    display: block !important;',
            '    opacity: 0;',
            '    visibility: hidden;',
            '    transition: opacity 0.3s ease, visibility 0.3s ease;',
            '    pointer-events: none;',
            '    background: rgba(255, 255, 255, 0.95) !important;',
            '    border-radius: 50% !important;',
            '    padding: 6px !important;',
            '    box-sizing: border-box !important;',
            '    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15) !important;',
            '}',
            // When form is visible, show the close button
            '.vev-form-visible #eFBSP-F08EL,',
            '#eFBSP-F08EL.vev-close-visible {',
            '    opacity: 1 !important;',
            '    visibility: visible !important;',
            '    pointer-events: auto !important;',
            '}',
            // Ensure the inner wrapper and shape fill the close button area
            '#eFBSP-F08EL .__wc,',
            '#eFBSP-F08EL .shape {',
            '    width: 100% !important;',
            '    height: 100% !important;',
            '    display: block !important;',
            '}',
            // Gray X icon
            '#eFBSP-F08EL svg {',
            '    width: 100% !important;',
            '    height: 100% !important;',
            '    fill: #666666 !important;',
            '}',
            // Add hover effect for better UX
            '#eFBSP-F08EL:hover {',
            '    background: rgba(255, 255, 255, 1) !important;',
            '    box-shadow: 0 2px 12px rgba(0, 0, 0, 0.2) !important;',
            '}',
            '#eFBSP-F08EL:hover svg {',
            '    fill: #333333 !important;',
            '}',
            // Mobile styles - position button and fix nested scroll
            '@media (max-width: 768px) {',
            '    #eFBSP-F08EL {',
            '        top: 54px !important;',
            '        right: 10.5% !important;',
            '        width: 30px !important;',
            '        height: 30px !important;',
            '        padding: 5px !important;',
            '    }',
            '    .fixed {',
            '        position: fixed !important;',
            '        top: 0 !important;',
            '        right: 0 !important;',
            '        width: 100% !important;',
            '        height: 100% !important;',
            '        overflow-y: auto !important;',
            '        overflow-x: hidden !important;',
            '        -webkit-overflow-scrolling: touch !important;',
            '    }',
            '    #ef03DzcRU8o {',
            '        max-height: none !important;',
            '        height: auto !important;',
            '        overflow: visible !important;',
            '    }',
            '}'
        ].join('\n');
        
        shadowRoot.appendChild(styleEl);

        // Track form visibility state
        var isFormVisible = false;

        function checkFormVisibility() {
            var formFrame = shadowRoot.querySelector('#ef03DzcRU8o');
            if (!formFrame) return;

            var frameRect = formFrame.getBoundingClientRect();
            var computedStyle = window.getComputedStyle(formFrame);
            
            // Form is visible if it has positive dimensions and is displayed
            var nowVisible = frameRect.width > 0 && 
                             frameRect.height > 0 &&
                             computedStyle.display !== 'none' &&
                             computedStyle.visibility !== 'hidden' &&
                             computedStyle.opacity !== '0';

            if (nowVisible !== isFormVisible) {
                isFormVisible = nowVisible;
                updateUIState();
            }
        }

        function updateUIState() {
            // Find all header elements that might block the close button
            var headers = document.querySelectorAll('[class*="h-[120px]"], [class*="fixed"][class*="top-0"], header.global, .header__top');
            
            if (isFormVisible) {
                closeButton.classList.add('vev-close-visible');
                formContainer.classList.add('vev-form-visible');
                document.body.classList.add('vev-form-open');
                vevContainer.style.position = 'relative';
                vevContainer.style.zIndex = '99';
                
                // Lower z-index of all header elements
                headers.forEach(function(header) {
                    header.style.zIndex = '5';
                });
            } else {
                closeButton.classList.remove('vev-close-visible');
                formContainer.classList.remove('vev-form-visible');
                document.body.classList.remove('vev-form-open');
                vevContainer.style.zIndex = '';
                
                // Restore header z-index
                headers.forEach(function(header) {
                    header.style.zIndex = '';
                });
            }
        }

        // Listen for clicks on the trigger button
        if (triggerButton) {
            triggerButton.addEventListener('click', function() {
                // Delay check to allow VEV animation to start
                setTimeout(checkFormVisibility, 150);
                setTimeout(checkFormVisibility, 500);
            });
        }

        // Watch for style/attribute changes on form elements
        var observer = new MutationObserver(function() {
            // Small delay to let VEV finish its changes
            setTimeout(checkFormVisibility, 50);
        });

        var formFrame = shadowRoot.querySelector('#ef03DzcRU8o');
        if (formFrame) {
            observer.observe(formFrame, {
                attributes: true,
                attributeFilter: ['class', 'style'],
                subtree: false
            });
        }

        if (formContainer) {
            observer.observe(formContainer, {
                attributes: true,
                attributeFilter: ['class', 'style'],
                childList: true,
                subtree: true
            });
        }

        // Periodic check as fallback since VEV may change things dynamically
        setInterval(checkFormVisibility, 500);

        // Initial check
        setTimeout(checkFormVisibility, 500);
        setTimeout(checkFormVisibility, 1500);
    }

    function waitForVev() {
        var vevContainer = document.querySelector('.vev');
        if (!vevContainer) {
            setTimeout(waitForVev, 500);
            return;
        }

        var shadowRoot = findShadowRoot(vevContainer);
        if (!shadowRoot) {
            setTimeout(waitForVev, 500);
            return;
        }

        // Wait for VEV to fully initialize its content
        var closeButton = shadowRoot.querySelector('#eFBSP-F08EL');
        if (!closeButton) {
            setTimeout(waitForVev, 500);
            return;
        }

        initVevFormOverlay();
    }

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', function() {
            setTimeout(waitForVev, 1000);
        });
    } else {
        setTimeout(waitForVev, 1000);
    }
})();
